/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_ORDERS(state, orders) {
    state.orders = orders;
  },
  UPDATE_ORDERS_PAID(state, orders) {
    state.ordersPaid = orders;
  },
  UPDATE_ORDERS_ORDERED_NOT_PAID(state, orders) {
    state.ordersOrderedNotPaid = orders;
  },
  UPDATE_ORDERS_PAID_AND_SENT(state, orders) {
    state.ordersPaidAndSent = orders;
  },
  APPEND_ORDERS_PAID_AND_SENT(state, orders) {
    state.ordersPaidAndSent = [...state.ordersPaidAndSent, ...orders];
  },
  SET_PAID_AND_SENT_HAS_MORE(state, hasMore) {
    state.ordersPaidAndSentHasMore = hasMore;
  },
  UPDATE_ORDER_IS_SENT(state, order) {
    state.ordersPaid = state.ordersPaid.filter(
      (item) => item._id !== order._id,
    );
    state.ordersPaidAndSent = [...state.ordersPaidAndSent, order];
  },
  UPDATE_ORDER_IS_SEEN(state, order) {
    console.log(state.ordersPaid);
    console.log(order);
    const index = state.ordersPaid.findIndex((item) => item._id === order._id);
    state.ordersPaid[index].isSeen = true;
  },
  ADD_NEW_ORDER_PAID(state, order) {
    const exists = state.ordersPaid.some((o) => o._id === order._id);
    if (!exists) {
      state.ordersPaid = [order, ...state.ordersPaid];
    }
  },
  UPDATE_DELIVERY_TIME(state, time) {
    state.deliveryTime = time;
  },
  UPDATE_DELIVERY_ACTIVATION(state, bool) {
    state.deliveryPossible = bool;
  },
};
